<template>
  <div class="div-container" :class="{ 'div-container-inner': tabChoosed == '内饰' }"
       :style="{ backgroundImage: `URL(${bgImg})` }">

    <div class="title">Vehicle</div>
    <div class="top">
      <div class="car">
        <div class="car-name">
          <span @click="isShowCarListChange" class="car-name-pre" style="margin-right: 0;padding-right: 0.52vw;">新狮铂拓界</span>
          <span @click="isShowCarListChange">{{ carChoosed.name }}</span>
          <i @click="isShowCarListChange" class="el-icon-arrow-down jiantou" :class="{ 'open': isShowCarList }"></i>
          <div class="car-list" :class="{ 'open': isShowCarList }">
            <div class="car-list-item" v-for="item in carsList" :key="item.name" @click="chooseCar(item)" :code-stm="`event, PAGEURL页面, 车型卡片_新狮铂拓界${item.name}`"><span
              class="pre">新狮铂拓界</span>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="tab">
        <div class="tab-item" :class="{ 'tab-item-active': item == tabChoosed }" v-for="item in tabsList" :key="item" :code-stm="`event, PAGEURL页面, 新狮铂拓界外观/内饰切换类型_${item}`"
             @click="chooseTab(item)">{{ item }}</div>
      </div>
    </div>
    <img :src="origin+carImg" alt="" class="car-img" v-if="tabChoosed == '外观'">
    <div class="bottom">
      <div class="color" v-if="tabChoosed == '外观' || !isPortrait">
        <div class="color-name">{{ colorChoosed.name }}</div>
        <div class="color-box" :class="colorsList.length > 6 ? 'wrap-box':''">
          <div :code-stm="`event, PAGEURL页面, 新狮铂拓界外观颜色_${item.name}`"
            class="color-box-item" :class="colorsList.length > 6 ? 'wrap-item':''" v-for="item in colorsList" :key="item.name" @click="chooseColor(item, 'click')"
            :style="{ backgroundImage: `URL(${origin+item.icon})` }">
            <i class="el-icon-check" v-if="item.name == colorChoosed.name"
               :style="{ color: item.name != '珍珠白' ? '#fff' : '#000' }"></i>
          </div>
        </div>
      </div>
      <div class="inner" v-if="tabChoosed == '内饰' || !isPortrait">
        <div class="inner-name">内饰颜色：{{ innerChoosed.name }}</div>
        <div class="inner-box">
          <div class="inner-box-item" v-for="item in innerList" :key="item.name" @click="chooseInner(item,'click')" :code-stm="`event, PAGEURL页面, 新狮铂拓界内饰颜色_${item.name}`"
               :style="{ backgroundImage: `URL(${origin+item.icon})` }">
            <i class="el-icon-check" v-if="item.name == innerChoosed.name"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="tip">*以上车辆配置信息所用图片仅供参考，具体产品相关细节以最终交付实车为准。</div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowCarList: false,
      carsList: [
        {
          name: "",
          colorsList: [
            {
              "name": "丛林绿",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlvche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlv.png"
            },
            {
              "name": "钻海蓝",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/zuanhailanche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zuanhailan.png"
            },
            {
              "name": "珍珠白",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubaiche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubai.png"
            },
            {
              "name": "凌霜灰",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghuiche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghui.png"
            },
            {
              "name": "星际灰",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihuiche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihui.png"
            },
            {
              "name": "极光黑",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/jiguangheiche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/jiguanghei.png"
            },
            {
              "name": "哑光灰",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/yaguanghuiche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/yaguanghui.png"
            },
            {
              "name": "丛林绿（黑顶/双色）",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlvshaungseche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlvshuangse.png"
            },
            {
              "name": "珍珠白（黑顶/双色）",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubaishuangseche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubaishuangse.png"
            },
            {
              "name": "凌霜灰（黑顶/双色）",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghuishuangseche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghuishuangse.png"
            },
            {
              "name": "星际灰（黑顶/双色）",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihuishuangseche.png",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihuishuangse.png"
            }
          ],
          innerList: [
            {
              name: '黑色内饰',
              icon: '/assets/~/media/images/vehicle/new-sportage/color/inner/heise.png',
              img: '/assets/~/media/images/vehicle/new-sportage/color/inner/heisetu.jpg'
            },
            {
              name: '黑咖内饰',
              icon: '/assets/~/media/images/vehicle/new-sportage/color/inner/heika.png',
              img: '/assets/~/media/images/vehicle/new-sportage/color/inner/heikatu.jpg'
            },
            {
              name: '黑红内饰',
              icon: '/assets/~/media/images/vehicle/new-sportage/color/inner/heihong.png',
              img: '/assets/~/media/images/vehicle/new-sportage/color/inner/heihongtu.jpg'
            }
          ],
        },
        {
          name: "X-Line",
          colorsList:[
            {
              "name": "丛林绿",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlv.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlineconglinlvche.png"
            },
            {
              "name": "钻海蓝",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zuanhailan.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinezuanhailanche.png"
            },
            {
              "name": "珍珠白",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubai.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinezhenzhubaiche.png"
            },
            {
              "name": "凌霜灰",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghui.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinelingshuanghuiche.png"
            },
            {
              "name": "星际灰",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihui.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinexingjihuiche.png"
            },
            {
              "name": "极光黑",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/jiguanghei.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinjiguangheiche.png"
            },
            {
              "name": "哑光灰",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/yaguanghui.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlineyaguanghuiche.png"
            },
            {
              "name": "丛林绿（黑顶/双色）",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/conglinlvshuangse.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlineconglinlvshuangseche.png"
            },
            {
              "name": "珍珠白（黑顶/双色）",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/zhenzhubaishuangse",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinezhenzhubaishuangseche.png"
            },
            {
              "name": "凌霜灰（黑顶/双色）",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/lingshuanghuishuangse.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinelingshuanghuishuangseche.png"
            },
            {
              "name": "星际灰（黑顶/双色）",
              "icon": "/assets/~/media/images/vehicle/new-sportage/color/outer/xingjihuishuangse.png",
              "img": "/assets/~/media/images/vehicle/new-sportage/color/xlineouter/xlinexingjihuishuangseche.png"
            }
          ],
          innerList: [
            {
              name: '黑棕内饰',
              icon: '/assets/~/media/images/vehicle/new-sportage/color/inner/heizong.png',
              img: '/assets/~/media/images/vehicle/new-sportage/color/inner/heizongtu.jpg'
            }
          ],
        }
      ],
      carChoosed: {},
      carBgImg: require('../assets/images/ev6/out-inner-bg.png'),
      bgImg: require('../assets/images/ev6/out-inner-bg.png'),
      tabsList: ["外观", "内饰"],
      tabChoosed: "外观",
      colorsList: [],
      colorChoosed: "",
      carImg: "",
      innerList: [],
      innerChoosed: {},
      innerImg: "",
      origin: "",
    };
  },
  watch: {
    carChoosed(n) {
      console.log(n);
      this.colorsList = this.carChoosed.colorsList
      this.innerList = this.carChoosed.innerList
      this.innerChoosed = this.innerList[0]
      if (this.tabChoosed == "外观") {
        this.chooseColor(this.colorsList[0])
      } else {
        this.chooseInner(this.innerList[0])
      }
    }
  },
  mounted: function () {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV == "production") {
      this.origin = "https://www.kia.cn"
    }
    this.carChoosed = this.carsList[0]
  },
  methods: {
    isShowCarListChange(){
      this.isShowCarList = !this.isShowCarList
    },
    chooseTab(item) {
      this.tabChoosed = item;
      if (item == "内饰") {
        this.chooseInner(this.innerChoosed)
      } else {
        this.chooseColor(this.colorChoosed)
      }
      this.maidian(`新狮铂拓界型页-外观内饰组件-tab选择-${item}`)
    },
    chooseColor(item, type) {
      this.colorChoosed = item
      this.carImg = item.img
      this.tabChoosed = "外观"
      this.bgImg = this.carBgImg
      if (type == 'click') {
        // 手动点击才记录埋点
        this.maidian(`新狮铂拓界型页-外观内饰组件-颜色选择-${item.name}`)
      }
    },
    chooseInner(item,type) {
      this.innerChoosed = item
      this.innerImg = item.img
      this.bgImg = this.origin+this.innerImg
      this.tabChoosed = "内饰"
      if (type == 'click') {
        this.maidian(`新狮铂拓界型页-外观内饰组件-内饰选择-${item.name}`)
      }
    },
    chooseCar(item) {
      if (!this.isShowCarList) {
        return
      }
      this.carChoosed = item
      this.isShowCarList = false
      this.maidian(`新狮铂拓界型页-外观内饰组件-选择车款-新狮铂拓界型页 ${item.name}`)
    },
    maidian(item) {
      console.log('埋点',item);
      try {
        stm_clicki("send", "event", window.location.href+'页面', "点击", item);
      } catch (e) {
        console.error(e);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$screen_pc: 1920;

@function rempc($px) {
  @return ($px/$screen_pc)*100+vw;
}

.div-container {
  width: 100%;
  height: 100%;
  padding: 4.51vw 11.30vw;
  box-sizing: border-box;
  position: relative;
  background-size: cover;
  .preLoad {
    opacity: 0;
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .title {
    color: rgba(5, 20, 31, 0.8);
    font-size: rempc(18);
    font-weight: 600;
    line-height: rempc(28);
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    width: calc(100% - 22.6vw);
    z-index: 9;

    .car {
      position: relative;

      &-name {
        color: rgba(5, 20, 31, 0.8);
        font-size: rempc(48);
        line-height: rempc(72);
        display: flex;
        align-items: center;
        cursor: pointer;

        &-pre {
          font-weight: 600;
          margin-right: rempc(10);
        }

        .jiantou {
          width: rempc(48);
          margin-left: rempc(10);
          transition: transform 0.3s ease;
          transform: rotate(0deg);
          font-weight: 600;

          &.open {
            transform: rotate(180deg);
          }
        }

      }

      &-list {
        position: absolute;
        top: rempc(72);
        width: rempc(310);
        border-radius: rempc(10) rempc(10);
        background: #fff;
        cursor: auto;
        overflow: hidden;
        opacity: 0;
        transform: translateY(-10%);
        transition: all .5s;

        &.open {
          opacity: 1;
          transform: translateY(10%);

          .car-list-item {
            cursor: pointer;
          }
        }

        &-item {
          padding: 0 rempc(20);
          height: rempc(60rem);
          line-height: rempc(60);
          cursor: auto;
          font-size: rempc(32);


          .pre {
            margin-right: rempc(10);
            font-weight: 600;
          }

          &:hover {
            background: #000;
            color: #fff;
          }
        }
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rempc(32);
      line-height: rempc(48);
      color: rgba(5, 20, 31, 1);

      &-item {
        padding: rempc(4) 0 0;
        cursor: pointer;
        margin-right: rempc(32);
        font-family: xihei;

        &:last-child {
          margin-right: 0;
        }

        &-active {
          font-family: chuhei;
          position: relative;

          &::before {
            content: "";
            width: 100%;
            height: rempc(4);
            background-color: rgba(5, 20, 31, 1);
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .bottom {
    width: calc(100% - 22.6vw);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    // top: 34.5vw;
    top: 81.5vh;
    .color,
    .inner {
      &-name {
        color: #05141F;
        font-family: chuhei;
        font-size: rempc(18);
        line-height: rempc(28);
        margin-bottom: rempc(16);
      }

      &-box {
        display: flex;

        &-item {
          width: rempc(45);
          height: rempc(45);
          // border: 0.5px solid #c3c7c9;
          border-radius: 50%;
          background-size: cover;
          position: relative;
          cursor: pointer;
          margin-right: rempc(15);

          .el-icon-check {
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: rempc(30);
            font-weight: bold;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .wrap-box {
        flex-wrap: wrap;
        justify-content: flex-start;
        width: 100%;
      }

      .wrap-item {
        margin-right: rempc(15) !important;
        //margin-left: rempc(15);
        margin-bottom: rempc(10);

        &:last-child {
          margin-right: rempc(15) !important;
        }
      }
    }

    .inner-box {
      justify-content: flex-end;
    }
  }

  .tip {
    color: rgba(5, 20, 31, 0.8);
    font-size: rempc(12);
    line-height: rempc(18);
    position: absolute;
    right: 11vw;
    // top: 32.5vw;
    bottom: 19.5vh;
  }

  .car-img {
    width: rempc(1290);
    height: rempc(600);
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
  }

  &-inner {
    color: #fff;

    .title {
      color: #fff;
    }

    .top {
      .car-name {
        color: #fff;

        .car-list-item {
          color: #05141F;

          &:hover {
            color: #fff;
          }
        }
      }

      .tab {
        color: #fff;

        &-item {
          &::before {
            background-color: #fff;
          }
        }
      }
    }

    .bottom {

      .color-name,
      .inner-name {
        color: #fff;
      }

    }

    .tip {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  @media (max-width: 768px) {
    height: 581px;
    padding: 68px 20px;
    background-position: 56%;

    .title {
      font-size: 14px;
      line-height: 100%;
    }

    .top {
      width: calc(100% - 40px);
      margin-top: 8px;

      .car {
        &-name {
          font-size: 24px;
          line-height: 30px;

          &-pre {
            font-weight: 600;
            margin-right: 5px;
          }

          .jiantou {
            width: 24px;
            margin-left: 5px;
          }
        }

        &-list {
          top: 30px;
          width: 180px;
          border-radius: 5px;

          &-item {
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;

            .pre {
              margin-right: 5px;
            }
          }
        }
      }

      .tab {
        font-size: 18px;
        line-height: 26px;

        &-item {
          padding: 4px 0 0;
          margin-right: 16px;

          &-active {
            &::before {
              height: 2px;
            }
          }
        }
      }
    }

    .bottom {
      width: calc(100% - 40px);
      top: unset;
      bottom: 52px;
      .color,
      .inner {
        &-name {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 10px;
        }
        &-box {
          &-item {
            width: 33px;
            height: 33px;
            .el-icon-check {
              font-size: 18px;
            }

            &:not(.wrap-item) {
              margin-right: 12px;

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }

        .wrap-box {
          flex-wrap: wrap;
          justify-content: center;
          width: 100%;
        }

        .wrap-item {
          margin-right: 14px !important;
          //margin-left: 15px;
          margin-bottom: 9px;

          &:last-child {
            margin-right: 15px !important;
          }
        }
      }
      .inner-box {
        justify-content: flex-start;
      }
    }
    .tip {
      width: 212px;
      height: 44px;
      flex-shrink: 0;
      text-align: right;
      font-size: 10px;
      line-height: 14px;
      right: 20px;
      top: unset;
      bottom: 126px;
    }
    .car-img {
      width: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      user-select: none;
    }
  }
}</style>
